<template>
  <div id="app" :class="['app-layout', { 'app-layout--full': isPublicPage }]">
    <header v-if="!isPublicPage" class="app-header">
      <div class="logo" @click="$router.push('/projects')">
        <img src="@/assets/logo.png" class="logo-icon" alt="妙笔" />
        <span class="logo-text">妙笔</span>
        <span class="logo-sub">创作中心</span>
      </div>
      <div class="header-actions">
        <el-button size="mini" @click="$router.push('/private-lib')">
          私有库
        </el-button>
        <el-button type="primary" size="mini" @click="$router.push('/projects')">
          作品库
        </el-button>
      </div>
    </header>
    <section class="app-body">
      <router-view />
    </section>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isPublicPage() {
      return !!this.$route.meta.public;
    }
  }
};
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f7fa;
  color: #303133;
}
.app-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: #ffffff;
  border-bottom: 1px solid #ebeef5;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.logo-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: #ff7f50;
  letter-spacing: 2px;
  line-height: 1;
}
.logo-sub {
  font-size: 12px;
  color: #909399;
  letter-spacing: 1px;
  padding-left: 4px;
  border-left: 1px solid #ebeef5;
  margin-left: 2px;
}
.app-body {
  flex: 1;
  overflow: hidden;
}
.app-layout--full .app-body {
  height: 100vh;
}
</style>
